import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface TitleAccentProps {
  className?: string;
}

const TitleAccent = ({ className }: TitleAccentProps) => {
  return (
    <motion.div
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className={cn("w-[72px] h-[3px] bg-electric rounded-sm origin-left", className)}
    />
  );
};

export default TitleAccent;
